module.exports = __webpack_public_path__ + "static/media/noble-logo.6f496c36.png";